import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Self-hosted fonts: keeps the app CSP-clean (style-src 'self') and
// off Google's CDN. unicode-range subsetting means the browser only fetches the
// Latin subset up front and the Bengali subset when :lang(bn) renders.
import "@fontsource-variable/inter";
import "@fontsource-variable/noto-sans-bengali";
import "@dp/ui/tokens.css";
import { App } from "./App.js";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
